export default __webpack_public_path__ + "static/media/our-history.1d11f97c.jpg";